export const getBearerToken = (): string => {
    const data = localStorage.getItem('persist:root');

    if (data) {
        return `${JSON.parse(data).token.replace(/"/g, '')}`;
    }

    return '';
};
